import ProfileDeleteReducer, {
  Actions as ProfileDeleteActions,
  initialState as initialProfileDeleteState,
  ProfileDeleteState,
} from 'src/app/ProfileDelete/redux/profileDelete.reducer'
import ProfileInfoReducer, {
  Actions as ProfileInfoActions,
  initialState as initialProfileInfoState,
  ProfileInfoState,
} from 'src/app/ProfileInfo/redux/profileInfo.reducer'
import SecondaryEmailReducer, {
  Actions as SecondaryEmailActions,
  initialState as initialSecondaryEmailState,
  SecondaryEmailState,
} from 'src/redux/reducers/data/secondaryEmails.reducer'

export type ProfileState = {
  profileInfo: ProfileInfoState
  secondaryEmails: SecondaryEmailState
  profileDelete: ProfileDeleteState
}

export const initialState: ProfileState = {
  profileInfo: initialProfileInfoState,
  secondaryEmails: initialSecondaryEmailState,
  profileDelete: initialProfileDeleteState,
}

export type Actions =
  | ProfileInfoActions
  | ProfileDeleteActions
  | SecondaryEmailActions

const ProfileReducer = (
  state = initialState,
  action: Actions,
): ProfileState => ({
  profileInfo: ProfileInfoReducer(
    state.profileInfo,
    action as ProfileInfoActions,
  ),
  secondaryEmails: SecondaryEmailReducer(
    state.secondaryEmails,
    action as SecondaryEmailActions,
  ),
  profileDelete: ProfileDeleteReducer(
    state.profileDelete,
    action as ProfileDeleteActions,
  ),
})

export default ProfileReducer
